import { useNavigate } from 'react-router-dom';
import { COURSES, LECTURERS, PLANS, AUDIT, pstat, pico, picol, picobg, afdata } from '../data/mockData';
import ProgTypeTag from '../components/ProgTypeTag';
import AiChatBox from '../components/AiChatBox';

const PORTFOLIO = [
  ['guide', 'fa-compass', <>Tourist<br />Guiding</>, 3],
  ['short', 'fa-clipboard-list', <>Short<br />Courses</>, 4],
  ['diploma', 'fa-graduation-cap', 'Diploma', 3],
  ['degree', 'fa-landmark-dome', <>Bachelor's</>, 2],
  ['masters', 'fa-trophy', <>Master's</>, 2],
  ['ai', 'fa-robot', <>AI<br />Enhanced</>, 3],
  ['social', 'fa-share-nodes', <>Social<br />Media</>, 3],
];

export default function DashboardPage() {
  const navigate = useNavigate();
  const totalEnrolled = COURSES.reduce((a, c) => a + c.enrolled, 0);

  return (
    <div>
      <div className="sh-ey">TMIS · AY2026 SEMESTER 1 · OCT 2026 – FEB 2027</div>
      <div className="sh-ti">Course Deployment Overview</div>
      <div className="sh-de">Manage TMIS's full tourism programme portfolio — Tourist Guiding through Master's degrees — with AI-assisted agentic scheduling and compliance monitoring.</div>

      <div className="alert">
        <i className="fa-solid fa-triangle-exclamation" />
        <div className="alert-t"><strong>AI Agent detected 2 conflicts in PLN-003</strong> — Guide trainer double-booked Tue 10:00 and LAB-AI near capacity. AI auto-fix is available.</div>
        <div className="alert-a"><button className="btn btn-gold btn-sm" onClick={() => navigate('/workflow')}><i className="fa-solid fa-robot" /> View AI Fix</button></div>
      </div>

      <div className="ai-agent-panel" style={{ marginBottom: '1.6rem' }}>
        <div className="ai-panel-header">
          <div className="ai-orb"><i className="fa-solid fa-robot" style={{ color: '#93C5FD', fontSize: '1.3rem' }} /></div>
          <div><div className="ai-panel-title">TMIS AI Agent</div><div className="ai-panel-sub">Ask anything about schedules, courses, conflicts, or compliance</div></div>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '.5rem', flexShrink: 0 }}>
            <span style={{ fontSize: '.72rem', background: 'rgba(147,197,253,.15)', border: '1px solid rgba(147,197,253,.25)', color: 'rgba(147,197,253,.9)', borderRadius: 6, padding: '.22rem .7rem', fontFamily: 'var(--font-mono)' }}>Simulated AI Agent</span>
          </div>
        </div>
        <AiChatBox
          initialMessage="Hello! I'm your TMIS AI Agent. Ask me about scheduling conflicts, course content, workload optimisation, or compliance checks."
          placeholder="Ask about schedules, courses, conflicts, or compliance…"
        />
      </div>

      <div className="g4" style={{ marginBottom: '1.5rem' }}>
        <div className="sc" style={{ borderTopColor: 'var(--ocean)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.45rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: 9, background: 'rgba(11,53,82,.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ocean)', fontSize: '.95rem' }}><i className="fa-solid fa-layer-group" /></div>
            <span className="pill p-ocean">6 active</span>
          </div>
          <div className="sv" style={{ color: 'var(--ocean)' }}>6</div>
          <div className="sl">Deployment Plans</div>
          <div className="ss"><i className="fa-solid fa-circle-check" style={{ color: 'var(--green)' }} /> 1 approved, 1 locked</div>
        </div>
        <div className="sc" style={{ borderTopColor: 'var(--gold-bg)', cursor: 'pointer' }} onClick={() => navigate('/catalogue')}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.45rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: 9, background: 'var(--gold-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--gold)', fontSize: '.95rem' }}><i className="fa-solid fa-book-open" /></div>
            <span className="pill p-lock">7 types</span>
          </div>
          <div className="sv" style={{ color: 'var(--ocean)' }}>{COURSES.length}</div>
          <div className="sl">Active Courses</div>
          <div className="ss"><i className="fa-solid fa-star" style={{ color: 'var(--gold-bg)' }} /> Incl. AI &amp; Social Media</div>
        </div>
        <div className="sc" style={{ borderTopColor: 'var(--red)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.45rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: 9, background: 'var(--red-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--red)', fontSize: '.95rem' }}><i className="fa-solid fa-triangle-exclamation" /></div>
            <span className="pill p-conf">Urgent</span>
          </div>
          <div className="sv" style={{ color: 'var(--red)' }}>2</div>
          <div className="sl">Active Conflicts</div>
          <div className="ss"><i className="fa-solid fa-robot" style={{ color: 'var(--violet)' }} /> AI auto-fix ready</div>
        </div>
        <div className="sc" style={{ borderTopColor: 'var(--sea-bg)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.45rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: 9, background: 'var(--sea-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--sea)', fontSize: '.95rem' }}><i className="fa-solid fa-users" /></div>
            <span className="pill p-sea">Enrolled</span>
          </div>
          <div className="sv" style={{ color: 'var(--ocean)' }}>{totalEnrolled.toLocaleString()}</div>
          <div className="sl">Total Enrolment</div>
          <div className="ss"><i className="fa-solid fa-arrow-up" style={{ color: 'var(--green)' }} /> <span className="sup">+12%</span> vs AY2025 S1</div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div className="ct">Programme Portfolio — AY2026 Sem 1</div>
        <div className="g7">
          {PORTFOLIO.map(([t, ic, lb, n]) => (
            <div key={t} style={{ textAlign: 'center', background: 'var(--cloud)', borderRadius: 9, padding: '.9rem .5rem', border: '1px solid var(--border)', cursor: 'pointer' }} onClick={() => navigate('/catalogue')}>
              <div style={{ fontSize: '1.4rem', marginBottom: '.38rem', color: 'var(--ocean)' }}><i className={`fa-solid ${ic}`} /></div>
              <div style={{ fontFamily: 'var(--font-serif)', fontWeight: 700, fontSize: '1.6rem', color: 'var(--ink)', lineHeight: 1 }}>{n}</div>
              <div style={{ fontSize: '.78rem', color: 'var(--slate)', marginTop: '.25rem', lineHeight: 1.4 }}>{lb}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="g2" style={{ alignItems: 'start', marginBottom: '1.5rem' }}>
        <div className="card">
          <div className="ct">Deployment Plans</div>
          {PLANS.map((p) => (
            <div key={p.id} className="plan-row" style={{ padding: '.85rem', marginBottom: '.55rem', cursor: 'pointer' }} onClick={() => navigate('/workflow')}>
              <div className="pl-ico" style={{ background: picobg(p.status) }}><i className={`fa-solid ${pico(p.status)}`} style={{ fontSize: '.95rem', color: picol(p.status) }} /></div>
              <div className="pl-in">
                <div className="pl-n" style={{ fontSize: 'var(--text-sm)' }}>{p.name}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginTop: '.2rem', flexWrap: 'wrap' }}>
                  <ProgTypeTag type={p.type} small />
                  {p.conf > 0 && <span style={{ fontSize: '.78rem', color: 'var(--red)', fontWeight: 700 }}><i className="fa-solid fa-robot" style={{ fontSize: '.68rem' }} /> AI: {p.conf} conflicts</span>}
                </div>
              </div>
              <span className={`pill ${pstat(p.status)}`}><span className="sdot" />{p.status}</span>
            </div>
          ))}
          <button className="btn btn-outline btn-sm" style={{ width: '100%', justifyContent: 'center', marginTop: '.5rem' }} onClick={() => navigate('/workflow')}>View all plans <i className="fa-solid fa-arrow-right" style={{ fontSize: '.72rem' }} /></button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div className="card">
            <div className="ct">Workflow Progress</div>
            <div className="wfbar">
              <div className="wfs done"><div className="wfn"><i className="fa-solid fa-check" style={{ fontSize: '.65rem' }} /></div><div><div className="wfl">Draft</div></div></div>
              <div className="wfs done"><div className="wfn"><i className="fa-solid fa-check" style={{ fontSize: '.65rem' }} /></div><div><div className="wfl">Submitted</div></div></div>
              <div className="wfs act"><div className="wfn">3</div><div><div className="wfl">Approved</div></div></div>
              <div className="wfs none"><div className="wfn">4</div><div><div className="wfl">Locked</div></div></div>
            </div>
            <div style={{ background: 'var(--sky-dim)', borderRadius: 8, padding: '.88rem 1rem', marginTop: '.78rem' }}>
              <div style={{ fontSize: 'var(--text-sm)', fontWeight: 700, color: 'var(--sky)', marginBottom: '.2rem' }}>Pending: Academic Head Review</div>
              <div style={{ fontSize: 'var(--text-sm)', color: 'var(--ink-s)' }}>PLN-001 Tourist Guiding Cert submitted · awaiting Dr. Lim's approval</div>
            </div>
          </div>
          <div className="card">
            <div className="ct">Lecturer Load — Top 5</div>
            {LECTURERS.slice(0, 5).map((l) => (
              <div key={l.id} style={{ marginBottom: '.82rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.32rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '.55rem' }}>
                    {/* l.bg is a fixed gradient, not theme-flipping — var(--surface)
                        goes near-black in dark mode and disappears against it. */}
                    <div style={{ width: 26, height: 26, borderRadius: 6, background: l.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.65rem', fontWeight: 700, color: '#fff', fontFamily: 'var(--font-mono)', flexShrink: 0 }}>{l.ini}</div>
                    <span style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--ink)' }}>{l.name.split(' ').slice(0, 2).join(' ')}</span>
                  </div>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.75rem', fontWeight: 700, color: l.load >= l.max ? 'var(--red)' : l.load >= l.max * 0.85 ? 'var(--gold)' : 'var(--sea)' }}>{l.load}/{l.max}h</span>
                </div>
                <div className="pt-track"><div className={`pt-fill ${l.load >= l.max ? 'pf-coral' : l.load >= l.max * 0.85 ? 'pf-gold' : 'pf-sea'}`} style={{ width: `${(l.load / l.max * 100).toFixed(0)}%` }} /></div>
              </div>
            ))}
          </div>
          <div className="card">
            <div className="ct">Quick Actions</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.55rem' }}>
              <button className="btn btn-ai" style={{ justifyContent: 'flex-start' }} onClick={() => navigate('/ai')}><i className="fa-solid fa-robot" /> Open AI Agent Hub</button>
              <button className="btn btn-primary" style={{ justifyContent: 'flex-start' }} onClick={() => navigate('/timetable')}><i className="fa-solid fa-calendar-days" /> Timetable Scheduler</button>
              <button className="btn btn-outline" style={{ justifyContent: 'flex-start' }} onClick={() => navigate('/reports')}><i className="fa-solid fa-chart-bar" /> Analytics Dashboard</button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="flex-b" style={{ marginBottom: '1rem' }}>
          <div className="ct" style={{ margin: 0 }}>Recent Activity</div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/audit')}>View audit trail <i className="fa-solid fa-arrow-right" style={{ fontSize: '.72rem' }} /></button>
        </div>
        {AUDIT.slice(0, 6).map((a, i) => {
          const [bg, col, icon] = afdata(a.tag);
          return (
            <div key={i} className="af">
              <div className="af-ic" style={{ background: bg, color: col }}><i className={`fa-solid ${icon}`} /></div>
              <div className="af-in"><div className="af-n">{a.action} — <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.75rem', color: 'var(--ocean)' }}>{a.detail}</span></div><div className="af-m">{a.user}</div></div>
              <div className="af-t">{a.time.split(' ').slice(0, 2).join(' ')}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
